/**
 * Převede jméno na Title Case.
 * Funguje správně pro:
 *   - "PETR VOJTA"       → "Petr Vojta"
 *   - "karolína kolářová"→ "Karolína Kolářová"
 *   - "marie-claire"     → "Marie-Claire"
 *   - "  extra  spaces " → "Extra Spaces"
 */
export function toTitleCase(str: string): string {
  if (!str) return str;
  return str
    .trim()
    .replace(/\s+/g, " ")
    .split(" ")
    .map(word =>
      word
        .split("-")
        .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join("-")
    )
    .join(" ");
}
